import { render, staticRenderFns } from "./FeeManager.vue?vue&type=template&id=7dd5806a&scoped=true&"
import script from "./FeeManager.vue?vue&type=script&lang=js&"
export * from "./FeeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5806a",
  null
  
)

export default component.exports